import { setUserTestId } from 'ducks/evaluatedUser'
import { interpretationSelector } from 'ducks/ui'
import { FC, useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import getOneResultBetesa from 'services/common/betesa/getResultByIdTest'
import { BetesaScore } from 'types/common'
import Loader from 'views/components/UI/Loader'
import { H5 } from 'views/components/UI/Text'
import { MainLayout } from 'views/layouts'
import { setEvaluatedUserId, setTestId } from 'views/screens/super-admin/percentiles/store'

import InterpretationForm, { InterpretationFormHandles } from '../components/interpretation-form/interpretation-form'
import ScoresTable from '../components/scores-table/scores-table'
import StressorsDetail from '../components/stressors-detail/stressors-detail'
import UserInfo from '../components/user-info/user-info'
import { Answer, IBetesaUserDetail, IItemDetailResult } from '../entities'
import {
  BetesaScores,
  CardInfoWithTable,
  CardRow,
  CardRowTableSticky,
  CardTitleWithColor,
  Container,
  InfoWrapper,
  LoaderContainer,
  WrapperContent,
} from './styled'
import { BetesaTitle, CompanySubtitle, WrapperTitle } from '../styled'
import SelfPerceptions from '../components/self-perceptions'
import { useLocation } from 'react-router-dom'
import EmotionalState from '../components/emotional-state'
import SuggestedDominance from '../components/suggested-dominance/suggested-dominance'
import ModalLoader from 'views/components/UI/ModalLoader'
import ConfirmationModal from '../components/confirmation-modal'

interface InterpretationDetailProps {
  title?: string
  disable?: boolean
  isReinterpretation?: boolean
}

const InterpretationDetail: FC<InterpretationDetailProps> = ({
  title = 'Betesas por interpretar',
  disable = false,
  isReinterpretation = false,
}) => {
  const { search } = useLocation()
  const queryParams = new URLSearchParams(search)
  const company = queryParams.get('company')
  const dispatch = useDispatch()
  const isInterpreted = useSelector(interpretationSelector)
  const { token } = useSelector((state: any) => state.user)
  const [userDetails, setUserDetails] = useState<IBetesaUserDetail | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [previousInterpretationInfo, setPreviousInterpretationInfo] = useState<any>({})
  const [isProcessDevelop, setIsProcessDevelop] = useState<boolean>(false)
  const [interpretationUserTestId, setInterpretationUserTestId] = useState<number | null>(null)
  const [suggestedDominance, setSuggestedDominance] = useState('')
  const [previousBetesas, setPreviousBetesas] = useState<any>({})
  const interpretationFormRef = useRef<InterpretationFormHandles>(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [modalMessage, setModalMessage] = useState('')
  const [modalTitle, setModalTitle] = useState('')
  const [confirmButtonText, setConfirmButtonText] = useState('')
  const [confirmAction, setConfirmAction] = useState<(() => void) | null>(null)

  const scores = {
    FI: 0,
    BI: 0,
    BD: 0,
    FD: 0,
  }
  const [chapters, setChapters] = useState<IItemDetailResult[]>([
    {
      chapter_name: 'Estresores',
      scores,
    },
  ])

  const [currentTotalsSummary, setCurrentTotalsSummary] = useState<BetesaScore>(scores)

  const [stressors, setStressors] = useState<Answer[]>([
    {
      text: 'Estresores',
      score: 0,
    },
  ])
  const [emotionalState, setEmotionalState] = useState<Answer[]>([])

  const [selfPerceptionScores, setSelfPerceptionScores] = useState<BetesaScore[]>([scores])
  const [selfPerceptionsTextItems, setSelfPerceptionsTextItems] = useState<string[]>([])

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const id = searchParams.get('id')

    if (id !== null) {
      getOneResultBetesa(token, parseInt(id)).then((res: any) => {
        if (Object.keys(res.data).length > 0) {
          setInterpretationUserTestId(res.data.betesa_user_detail.user_test_id)
          setLoading(false)
          setUserDetails(res.data.betesa_user_detail)
          setChapters(res.data.betesa_results_detail.chapters)
          setEmotionalState(res.data.betesa_results_detail.emotional_state_answers)
          setStressors(res.data.betesa_results_detail.stressors_answers)
          setSelfPerceptionScores(res.data.betesa_results_detail.self_perception_scores)
          setCurrentTotalsSummary(res.data.betesa_results_detail.current_total_summary)
          setSuggestedDominance(res.data.betesa_predict.domination)
          setPreviousInterpretationInfo({
            hasPreviousInterpretation: res.data.has_previous_interpretation,
            result: res.data.betesa_previous_interpretation,
          })
          setIsProcessDevelop(res.data.betesa_user_detail.type_process_id === 2)
          setSelfPerceptionsTextItems(res.data.self_perception_items)
          setPreviousBetesas(res.data.othersBetesaInPlatform)
        }
      })
    }
  }, [token])

  useEffect(() => {
    dispatch(setEvaluatedUserId(Number(userDetails?.user_id)))
    dispatch(setTestId(Number(userDetails?.test_id)))
    dispatch(setUserTestId(Number(userDetails?.user_test_id)))
  }, [dispatch, isInterpreted, userDetails])

  const handleOpenModal = (message: string, action: () => void, modalTitleText: string, buttonText: string) => {
    setModalMessage(message)
    setModalTitle(modalTitleText)
    setConfirmButtonText(buttonText)
    setConfirmAction(() => action)
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    setModalMessage('')
    setModalTitle('')
    setConfirmButtonText('')
    setConfirmAction(null)
  }

  const handleConfirm = () => {
    if (confirmAction) {
      confirmAction()
    }
    handleCloseModal()
  }

  if (!userDetails) {
    return <ModalLoader isLoading={true} />
  }

  const handleAcceptSuggestion = () => {
    if (interpretationFormRef.current) {
      const { selectedDomination } = interpretationFormRef.current
      if (selectedDomination) {
        handleOpenModal(
          'Al aceptar la sugerencia perderás tu selección actual, está será remplazada por la sugerida por la IA.',
          () => interpretationFormRef.current?.submitInterpretation(suggestedDominance, true),
          '¿Deseas aceptar la sugerencia de dominancia?',
          'Sí, aceptar sugerencia'
        )
      } else {
        interpretationFormRef.current.submitInterpretation(suggestedDominance, true)
      }
    }
  }

  const handleSubmitFrom = () => {
    if (interpretationFormRef.current) {
      const { selectedDomination } = interpretationFormRef.current
      const activeTab = queryParams.get('activeTab')

      if (previousInterpretationInfo.hasPreviousInterpretation || activeTab === 'withPrevious') {
        interpretationFormRef.current?.submitInterpretation(selectedDomination, false)
      } else {
        handleOpenModal(
          'Al escoger una dominancia pierdes la sugerencia de la IA.',
          () => interpretationFormRef.current?.submitInterpretation(selectedDomination, false),
          '¿Deseas enviar la dominancia manualmente?',
          'Sí, tomar la dominancia manual'
        )
      }
    }
  }

  const content = (
    <>
      {loading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <Container>
          {!isReinterpretation && (
            <WrapperTitle>
              <BetesaTitle>{title}</BetesaTitle>
              <CompanySubtitle>{company}</CompanySubtitle>
            </WrapperTitle>
          )}

          <WrapperContent>
            <BetesaScores>
              <CardRowTableSticky>
                <CardInfoWithTable>
                  <CardTitleWithColor>
                    <H5 style={{ marginBottom: 0 }}>Puntajes</H5>
                  </CardTitleWithColor>
                  <ScoresTable
                    chapters={chapters}
                    selfPerceptionScores={selfPerceptionScores}
                    totalSummary={currentTotalsSummary}
                  />
                </CardInfoWithTable>
              </CardRowTableSticky>
            </BetesaScores>

            <InfoWrapper>
              {suggestedDominance &&
                !previousInterpretationInfo.hasPreviousInterpretation &&
                !userDetails?.old_platform && (
                  <SuggestedDominance suggestedDominance={suggestedDominance} onAccept={handleAcceptSuggestion} />
                )}
              <InterpretationForm
                ref={interpretationFormRef}
                interpretation={userDetails?.domination}
                userIdParam={userDetails?.user_id}
                testIdParam={userDetails?.test_id}
                loadingState={setLoading}
                disabled={disable}
                userTestId={interpretationUserTestId ?? 0}
                oldPlatform={userDetails?.old_platform}
                previousInterpretationInfo={previousInterpretationInfo}
                onSubmit={handleSubmitFrom}
                isReinterpretation={isReinterpretation}
                othersBetesaInPlatform={previousBetesas}
              />
              <SelfPerceptions selfPerceptionsItems={selfPerceptionsTextItems} />
              <CardRow>
                {userDetails && (
                  <UserInfo
                    userName={userDetails.user_name}
                    age={userDetails?.age}
                    documentTypeName={userDetails.document_type_name}
                    document={userDetails.document}
                    previousInterpretationInfo={previousBetesas}
                    isProcessDevelop={isProcessDevelop}
                  />
                )}
              </CardRow>
              {emotionalState && <EmotionalState emotions={emotionalState} />}
              <StressorsDetail stressors={stressors} />
            </InfoWrapper>
          </WrapperContent>
          <ConfirmationModal
            open={modalOpen}
            onClose={handleCloseModal}
            onConfirm={handleConfirm}
            message={modalMessage}
            title={modalTitle}
            confirmButtonText={confirmButtonText}
          />
        </Container>
      )}
    </>
  )

  return isReinterpretation ? content : <MainLayout>{content}</MainLayout>
}

export default InterpretationDetail
